import React from "react";

import styles from "./index.module.scss";

const LoaderComponent = () => {
	return (
		<div className={styles.wrap}>
			<div className={styles.one}></div>
			<div className={styles.two}></div>
			<div className={styles.two}></div>
			<div className={styles.three}></div>
		</div>
	);
};

export default LoaderComponent;
